<template>
  <div class="cb-payment" v-if="!(showPmPicker && paymentMethodType)">
    <div class="cb-section" v-if="pm_list_filtered.length > 1 || showPmPicker">
    <template v-if="showPmPicker">
      <div class="cb-section__title cb-section__title--st cb-section__title--nospacing" style="margin-bottom:5px">{{t('payment_method.header.select')}}</div>
      <div class="cb-options cb-options--navi cb-options--condensed" v-for="(method, index) in pm_list_filtered" :key='index' v-cb-link = "'shadow'" @click="setPaymentType(method.type)">
        <div class="cb-options__group">
          <div class="cb-options__left cb-options__left--payment">
            <i v-if="display_icon(method)" :class="display_icon(method)" aria-hidden="true"></i>
          </div>
          <div class="cb-options__right cb-options__right--payment" style="line-height:normal;font-size:12px">
            <span class="cb-payment__text">{{display_name(method)}}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cb-payment__wrap cb-payment__wrap--fluid" v-if="pm_list_filtered.length <= 3">
        <div class="cb-payment__group" :style="[getTextColor(method.type),getBorder(method.type), getWidth]" :class="tabLayoutPaymentGroupClasses(method)" v-for="(method, index) in pm_list_filtered"  @click="setPaymentType(method.type)" v-cb-link="'color'" role="button" :data-cb-id="method.type" v-bind:key="index">
          <div class="cb-payment__method cb-payment__method--flex-column">
            <i v-if="display_icon(method)" :class="display_icon(method)" aria-hidden="true"></i>
            <span class="cb-payment__text" v-if="method.type != 'apple_pay'">{{display_name(method)}}</span>
          </div>
        </div>
      </div>
      <div v-else class="cb-payment__wrap cb-payment__wrap--alt" :style="backgroundColor">
        <select ref="select" type="text" v-cb-link = "'shadow'" class="cb-payment__select" @change="input($event)" v-model = "current_pm_type">
          <option v-bind:key="index" v-for="(method, index) in pm_list_filtered" :value="method.type">{{display_name(method)}}</option>
        </select>
        <label></label>
      </div>
    </template>
    </div>
    <transition name = "fade">
      <cb-modal :icon="'info'" :text="st('switch_payment_method')" v-if="showModalBox" class = "cb-transition__fade" :primary-action="t('modal_button.confirm')" :secondaryAction="t('modal_button.cancel')" :overlay="'true'" @clearModalDialog = "clearModalDialog()" @submit="switchPaymentType()">
      </cb-modal>
    </transition>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex"
import ModalBox from "@/components/collections/elements/ModalBox"
import PaymentHelper from "@/utils/payment-helper"
export default {
  mounted(){
    this.pm = this.pm_list_filtered.filter(pm => pm.type == this.paymentMethodType)[0];
  },
  computed: {
    ...mapGetters([
      "pm_list_filtered",
      "current_error"
    ]),
    getWidth() {
      return 'width:' + (100 / this.pm_list_filtered.length) + '%';
    },
    current_pm_type(){
      return this.paymentMethodType;
    }
  },
  components: {
    'cb-modal': ModalBox
  },
  destroyed(){
    this.$store.dispatch("reset_pm");
  },
  data() {
    return {
      pm: "",
      showModalBox: false,
      temp_type: "",
      recent_error: false
    }
  },
  props: ['editMode', 'subscribeMode', 'paymentMethodType', 'showPmPicker'],
  watch: {
    current_error(newValue, oldValue) {
      if(newValue != null) {
        this.recent_error = true;
      }
    }
  },
  methods: {
    tabLayoutPaymentGroupClasses(method) {
      return {
        'cb-payment__group--active': this.paymentMethodType == method.type,
        'cb-payment__group--vertical-middle': method.type == 'apple_pay'
      }
    },
    getColor(type) {
      if (this.paymentMethodType == type)
        return this.$store.getters.background_color;
    },
    getBorder(type) {
      if (this.paymentMethodType == type)
        return this.$store.getters.border_color;
    },
    getTextColor(type) {
      if (this.paymentMethodType == type)
        return this.$store.getters.color;
    },
    setPaymentType(type) {
      this.$store.dispatch('set_pm_consent', true);
      this.temp_type = type;
      if(this.$store.state.auth.pm_authorized && !this.recent_error){
        this.showModalBox = true;
      }
      else{
        this.$emit('setPaymentType', this.temp_type);
      }
    },
    input(event) {
      var product = this.pm_list_filtered.filter(({
        type
      }) => type == event.target.value)[0];
      if(product){
        this.setPaymentType(product.type);
      }
    },
    clearModalDialog(){
      this.showModalBox = false;
    },
    switchPaymentType(){
      this.$store.dispatch("reset_pm");
      this.$emit('setPaymentType',this.temp_type);
    },
    display_name(method){
      return PaymentHelper.getPaymentMethodDisplayName(method);
    },
    display_icon(method) {
      if(method.mode == "OFFLINE") {
       return `cb-icon ${PaymentHelper.getOfflinePaymentMethodIcon(method.type)}`;
      }
      switch(method.type) {
        case "card":
          return "cb-icon icon-credit-card";
        case "paypal_express_checkout":
          return "cb-icon cb-icon__paypal icon-paypal"
        case "venmo":
          return "cb-icon cb-icon__venmo icon-venmo"
        case "amazon_payments":
          return "cb-icon cb-icon__amazon-pay icon-amazon-pay"
        case "apple_pay":
          return "cb-icon__apple-pay icon-apple-pay-textual-border"
        case "ideal":
          return "cb-icon icon-iDeal"
        case 'sofort':
          return "cb-icon icon-sofort"
        case 'bancontact':
          return "cb-icon icon-bancontact"
        case 'google_pay':
          return "cb-icon icon-google-pay"
        case 'upi':
          return "cb-icon icon-upi"
        case 'giropay':
          return "cb-icon icon-giropay"
        case 'dotpay':
          return "cb-icon icon-dotpay"
        case 'faster_payments':
          return "cb-icon icon-faster-payments"
        case 'sepa_instant_transfer':
          return "cb-icon icon-sepa"
        case 'pay_to':
          return "cb-icon icon-payto"
        case 'klarna_pay_now':
          return "cb-icon icon-klarna"
        case "direct_debit":
          if(method.configuration && method.configuration.scheme) {
            switch (method.configuration.scheme) {
              case "SEPA":
                return "cb-icon icon-sepa"
              case "ACH":
              case "PAD":
              case "BECS":
              case "BECS(NZ)":
                return "cb-icon icon-bank"
              default:
                return "cb-icon cb-icon__direct-debit icon-direct-debit"
            }
          } else {
            return "cb-icon cb-icon__direct-debit icon-direct-debit"
          }
        case 'netbanking_emandates':
          return "cb-icon icon-bank"
        default:
          return false;
      }
    }
  }
}
</script>
